import { Moment } from 'moment';
import * as moment from 'moment';
import 'moment-duration-format';

export class AzcMoment {
	static formatEventDate(date: Moment | string): string {
		if (!date) {
			return null;
		}
		if (typeof(date) === 'string') {
			return date;
		}
		return date.format('YYYY-MM-DDTHH:mm');
	}

	static format(date: Moment | string): string | null {
		if (!date) {
			return null;
		}
		if (typeof(date) === 'string') {
			return date;
		}
		return date.format();
	}

	static getDuration(from: Moment | string, to: Moment | string): string {
		if (!from || !to) {
			return null;
		}
		const toMoment = moment(to);
		const duration = toMoment.diff(from);

		if (duration === 0) {
			return null;
		}

		return moment.duration(duration).format('h [hours]', 1);
	}

	static getDurationFormat(durationInMinutes?: number): string {
		if (!durationInMinutes) return null;

		const durationMoment = moment.duration(durationInMinutes, 'minutes');

		return durationInMinutes >= 60 ?
			durationMoment.format('h [hours]', durationInMinutes % 60 !== 0 ? 1 : 0)
			: durationMoment.format('m [minutes]');
	}

	static isSameDay(from: Moment | string, to: Moment | string): boolean {
		if (!from || !to) {
			return false;
		}
		return !moment(from).isAfter(to, 'day');
	}
}
